export default __webpack_public_path__ + "static/media/avatar.13783fa4.png";